import routeBuilder from './routes';
const view = {
  layout: 'TabView',
  routeBuilder,
};
export default view;
